<hc-modal class="admin-string-editor">
    <hc-modal-header>
        <span>{{ category + " " + type }} </span>
    </hc-modal-header>
    <hc-modal-body>
        <!-- Spinner while data is being loaded -->
        <div *ngIf="loading && !loadError" class="pd-loader">
            <hc-progress-spinner color="purple" [diameter]="50"></hc-progress-spinner>
        </div>

        <!-- Error loading content -->
        <div *ngIf="!loading && loadError" class="pd-permission-error">
            <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
            There was an error loading the {{ category + " " + type | lowercase }} content. Click below try again.
            <button hc-button size="lg" (click)="loadData()">Reload {{ type | lowercase }} data</button>
        </div>
        <div class="string-editor-body-container" [hidden]="loading || loadError">
            <div class="string-editor-control-bar">
                <em class="element-count"> {{ countText| lowercase }}</em>
                <button hc-button buttonStyle="primary" [hcPop]="addEditPop">Add {{ category }} {{ type }}</button>
            </div>
            <table class="hc-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let el of stringList; let i = index">
                        <td>{{ el.name }}</td>
                        <td [innerHTML]="el.description | sanitizeHtml"></td>
                        <td>
                            <div class="hc-table-actions">
                                <div [hcPop]="removePop" [context]="el"><span hcMenuIcon
                                        class="fa fa-trash hc-action-ico"
                                        [hcTooltip]="'Delete ' + type.toLowerCase()"></span></div>
                                <div [hcPop]="addEditPop" [context]="el" (click)="setStringField()"><span hcMenuIcon
                                        class="fa fa-pencil hc-action-ico" [hcTooltip]="'Edit ' + type.toLowerCase()">
                                    </span></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <hc-pop #removePop [verticalAlign]="'below'" (opened)="element = $event">
                <div class="remove-pop-body"> Are you sure you want to remove this {{ category + " " + type | lowercase
                    }}?</div>
                <div class="remove-pop-footer">
                    <button hc-button buttonStyle="link" (click)="removePop.close()" size="sm">Cancel</button>
                    <button hc-button buttonStyle="destructive" size="sm" (click)="remove(element)">Remove</button>
                </div>
            </hc-pop>
            <hc-pop #addEditPop [verticalAlign]="'below'" (opened)="element = $event">
                <hc-form-field>
                    <hc-label>Name:</hc-label>
                    <input hcInput [required]="true" [formControl]="nameControl"
                        [placeholder]="'Enter ' + type.toLowerCase() + ' name'" />
                </hc-form-field>
                <hc-label>Description: <span id="asterisk">*</span></hc-label>
                <quill-editor class="description-editor" [formControl]="descriptionControl"
                    [placeholder]="'Enter ' + type.toLowerCase() + ' description'" [modules]="quillConfig"
                    [styles]="quillStyles"></quill-editor>
                <div class="add-edit-pop-footer">
                    <button hc-button buttonStyle="link" (click)="resetAddEditPop()" size="sm">Cancel</button>
                    <button hc-button buttonStyle="primary" size="sm"
                        [disabled]="!nameControl.valid || !descriptionControl.valid || (!nameControl.dirty && !descriptionControl.dirty)"
                        (click)="save()">Save</button>
                </div>
            </hc-pop>
            <div class="hc-empty-table-block" *ngIf="!stringList || stringList.length === 0">
                <span class="hc-empty-table-block-ico hc-empty-ico"></span>
                <span class="hc-empty-table-block-msg">No {{ type | lowercase }}{{ type === 'Status' ? 'e': null}}s to
                    show.</span>
            </div>
        </div>
    </hc-modal-body>
    <hc-modal-footer [minimal]="true"></hc-modal-footer>
</hc-modal>